import { ParseKeys, TFunction } from "i18next";

// Placeholders live in the option data; known ones are translated on display.
const PLACEHOLDER_KEYS: Record<string, ParseKeys<"services">> = {
  "enter charger name": "wizard.placeholders.charger_name",
  "[add custom inclusion]": "wizard.placeholders.custom_inclusion",
  "insert link to payment": "wizard.placeholders.payment_link",
  "insert email for e-transfers": "wizard.placeholders.etransfer_email",
  "insert payee name i.e., ABC Inc": "wizard.placeholders.payee",
  "[add custom assumption]": "wizard.placeholders.custom_assumption",
};

export const placeholderLabel = (
  t: TFunction<"services">,
  placeholder?: string,
): string | undefined => {
  const key = placeholder && PLACEHOLDER_KEYS[placeholder];
  return key ? t(key) : placeholder;
};
